module.exports = __webpack_public_path__ + "img/guarantee@2x.214661e7.png";